import { jsx as _jsx } from "react/jsx-runtime";
import MessagingCopy from '../messaging/MessagingCopy';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import { useView } from './useView';
import { Step } from './Step';
import { Data } from '../signup-data/DATA';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { getGuessedDataBiden } from '../store/guessed-prefill/selectors';
import { useSelector } from 'react-redux';
import { StepTitle } from '../views-components/StepTitle';
export const CompanyNameView = () => {
  const stepKey = Step.CompanyName;
  const dataKey = Data.CompanyName;
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    isAssignedToVariant: isAssignedToVariantACQ0134
  } = useExperiment(ExperimentKeys.ACQ0134, TrackWhen.never);
  const guessedData = useSelector(getGuessedDataBiden(dataKey));
  const stepConfig = getStepConfig(stepKey);

  if (!stepConfig) {
    return null;
  }

  let helperText;

  if (isAssignedToVariantACQ0134()) {
    helperText = guessedData ? /*#__PURE__*/_jsx(MessagingCopy, {
      message: `views.${stepKey}.help`
    }) : /*#__PURE__*/_jsx(MessagingCopy, {
      message: `views.${stepKey}.subtitle`
    });
  }

  const title = isAssignedToVariantACQ0134() ? /*#__PURE__*/_jsx(StepTitle, {
    message: `views.${stepKey}.title.acq134`,
    stepKey: Step.CompanyDomain
  }) : null;
  return /*#__PURE__*/_jsx(BaseView, {
    helperText: helperText,
    title: title,
    children: /*#__PURE__*/_jsx(SignupDataInputForm, {
      dataKey: dataKey,
      inputMode: 'text',
      submit: submit
    }, dataKey)
  });
};